import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import { fetchProfile } from "../../utils/fetchProfile";
import { fetchSyncRawdata } from "../../utils/fetchSyncRawdata";
import Navbar from "../../Components/Navbar";
import TablePreparation from "./Table/TablePreparation";
import TablePeriod from "./Table/TablePeriod";
import TableLogDB from "./Table/TableLogDB";

import { Slide, toast } from "react-toastify";

import {
  FormControl,
  FormControlLabel,
  Checkbox,
  Grid,
  Button,
  Box,
  Typography,
  Autocomplete,
  Card,
  MenuItem,
  TextField,
} from "@mui/material";

import { ModalGenerateDB } from "../../Components/Fragments/Modals/ModalGenerateDB";
import { ModalSyncRawdata } from "./Modal/ModalSyncRawdata";
import { ModalUploadRetailerTemp } from "../../Components/Fragments/Modals/ModalUploadRetailer";
import { AllRetailersUploadModal } from "../../Components/Fragments/Modals/ModalAllRetailersUpload";
import { ModalConfirmation } from "../../Components/Fragments/Modals/ModalGeneral";

function DataProcessing() {
  const accessToken = Cookies.get("access_token") || "";

  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [dataProfile, setDataProfile] = useState([]);
  const [dataSyncRawdata, setDataSyncRawdata] = useState([]);
  const [dataDBSet, setDataDBSet] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openRetailerModal, setOpenRetailerModal] = useState(false);
  const [syncModalOpen, setSyncModalOpen] = useState(false);
  const [openAllRetailersUploadModal, setOpenAllRetailersUploadModal] = useState(false);
  const [openDialogConfirmationExport, setOpenDialogConfirmationExport] =
    useState(false);
  const [viewDataExport, setViewDataExport] = useState({
    title: null,
    process_at: null,
  });

  const [periodOptions, setPeriodOptions] = useState([]);
  const [retailerOptions, setRetailerOptions] = useState([]);
  const [selectedProjectType, setSelectedProjectType] = useState("rta_gt");
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedPreviousPeriod, setSelectedPreviousPeriod] = useState("");
  const [selectedRetailer, setSelectedRetailer] = useState("All Retailers");
  const [selectedDBSet, setSelectedDBSet] = useState("");
  const [selectedPeriods, setSelectedPeriods] = useState("");

  const [alreadyRunCreateDataPrep, setAlreadyRunCreateDataPrep] =
    useState(false);

  const [preparationData, setPreparationData] = useState([]);
  const [dataLogDB, setDataLogDB] = useState([]);
  const [dataPeriod, setDataPeriod] = useState([]);

  const [isAllPeriodsSelected, setIsAllPeriodsSelected] = useState(false);

  const projectTypes = [
    { label: "RTA GT", value: "rta_gt" },
    { label: "RTA MT", value: "rta_mt" },
    { label: "RDC GT", value: "rdc_gt" },
    { label: "RDC MT", value: "rdc_mt" },
    { label: "RDC PHARMACY", value: "rdc_pharmacy" },
  ];

  // disabled button if in 07:00 - 07:59 in GMT+7
  const checkingTimeMin = process.env.REACT_APP_DISABLE_SYNC_RAWDATA_START_ON;
  const checkingTimeMax = process.env.REACT_APP_DISABLE_SYNC_RAWDATA_END_ON;

  const now = new Date();
  const gmt7Hours = (now.getUTCHours() + 7) % 24;
  const gmt7Minutes = now.getUTCMinutes();
  const currentMinutes = gmt7Hours * 60 + gmt7Minutes;

  // Parse the min and max times
  const [minHour, minMinute] = checkingTimeMin.split(":").map(Number);
  const [maxHour, maxMinute] = checkingTimeMax.split(":").map(Number);
  const minMinutes = minHour * 60 + minMinute;
  const maxMinutes = maxHour * 60 + maxMinute;

  // Check if current time is within the range
  const isTimeDisabled =
    currentMinutes >= minMinutes && currentMinutes < maxMinutes;

  // const optionsWithAll = [{ id: 'all-retailers', retailer: 'All Retailers' }, ...retailerOptions];

  const optionsWithAll = [
    { id: "all-retailers", retailer: "All Retailers" },
    ...retailerOptions,
  ];

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "COA",
        "TL",
        "13",
        "14",
      ]);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (selectedProjectType && selectedPeriod) {
        fetchSyncRawdata(
          accessToken,
          setDataSyncRawdata,
          selectedProjectType,
          selectedPeriod || ""
        );
      } else if (!selectedProjectType || !selectedPeriod) {
        setDataSyncRawdata([]);
      }
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedProjectType, selectedPeriod]);

  useEffect(() => {
    const selectedArray = selectedPeriods.split(",").filter(Boolean);
    if (dataPeriod.length > 0 && selectedArray.length === dataPeriod.length) {
      setIsAllPeriodsSelected(true);
    } else {
      setIsAllPeriodsSelected(false);
    }
  }, [selectedPeriods, dataPeriod]);

  const handleCheckboxChange = (event, projectType) => {
    let updatedSelectedOptions = selectedDBSet.split(",").filter(Boolean);
    if (updatedSelectedOptions.includes(projectType)) {
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (item) => item !== projectType
      );
    } else {
      updatedSelectedOptions.push(projectType);
    }

    setSelectedDBSet(updatedSelectedOptions.join(","));
  };

  const handlePeriodsClick = (row) => {
    let updatedSelectedPeriods = selectedPeriods.split(",").filter(Boolean);

    if (updatedSelectedPeriods.includes(String(row.period))) {
      updatedSelectedPeriods = updatedSelectedPeriods.filter(
        (item) => item !== String(row.period)
      );
    } else {
      updatedSelectedPeriods.push(String(row.period));
    }

    setSelectedPeriods(updatedSelectedPeriods.join(","));
  };

  const handleSelectAllPeriods = () => {
    if (isAllPeriodsSelected) {
      setSelectedPeriods("");
      setIsAllPeriodsSelected(false);
    } else {
      const allPeriodIds = dataPeriod.map((p) => String(p.period)).join(",");
      setSelectedPeriods(allPeriodIds);
      setIsAllPeriodsSelected(true);
    }
  };

  async function fetchPeriodOptions(selectedProjectType) {
    setIsLoading(true);

    setPeriodOptions([]);

    let projectType = selectedProjectType.toLowerCase();

    if (projectType) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/reporting/period?project_type_id=${projectType}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const { data } = await response.json();
          const formattedPeriods = data.map((period) => ({
            period: period.name.toString(),
            id: period.id.toString(),
          }));
          setPeriodOptions(formattedPeriods);
        } else {
          setPeriodOptions([]);
        }
      } catch (error) {
        console.error(error);
      }
    } else if (!projectType) {
      setPeriodOptions([]);
    }
    setIsLoading(false);
  }

  async function fetchRetailerOptions(selectedProjectType) {
    setIsLoading(true);

    setRetailerOptions([]);

    if (selectedProjectType == "rta_mt") {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/data-processing-raw/rta_mt/retailer`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const { data } = await response.json();
          setRetailerOptions(data);
        } else {
          setRetailerOptions([]);
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchPeriodOptions(selectedProjectType);
      fetchRetailerOptions(selectedProjectType);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedProjectType]);

  const handleCreateDataPreparation = async () => {
    const formData = {
      project_type: selectedProjectType,
      period: selectedPeriod,
      prev_period: "0",
      need_transfer_data: "false",
      retailer: selectedRetailer !== "All Retailers" ? selectedRetailer : "",
      // ...(selectedRetailer !== "All Retailers" && { retailer: selectedRetailer }),
    };

    if (formData) setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/data-processing-single/data_preparation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success("Berhasil create data preparation step!");
        handleRefreshDataPreparation();
        handleRefresh();
      } else {
        const message = await response.json();
        toast.error(message.detail);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  async function fetchPreparationData(
    selectedProjectType,
    selectedPeriod,
    selectedRetailer
  ) {
    setIsLoading(true);
    let projectType = selectedProjectType.toLowerCase();

    if (projectType && selectedPeriod) {
      try {
        let url = new URL(
          `${process.env.REACT_APP_API_URL}/api/v1/data-processing/data_preparation`
        );
        url.searchParams.append("project_type", projectType);
        url.searchParams.append("period", selectedPeriod);

        if (selectedRetailer !== "All Retailers") {
          url.searchParams.append("retailer", selectedRetailer);
        }
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          const { data } = await response.json();
          setPreparationData(data);
        } else if (response.status === 404) {
          if (!alreadyRunCreateDataPrep) {
            handleCheck();
            setAlreadyRunCreateDataPrep(true);
          } else {
            setPreparationData([]);
          }
        } else {
          setPreparationData([]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setPreparationData([]);
      setIsLoading(false);
    }
  }

  // const filteredPreparationData = preparationData.filter(item => {
  //   if (selectedProjectType == "rta_mt") {
  //     if (selectedRetailer == "all-retailers" || selectedRetailer == "All Retailers") {
  //       return item.description !== "Upload Retailer Data" && item.description !== "Crosscoding Product";
  //     }
  //     return item.description !== "Completeness Check" && item.description !== "Calculate Projection Factor";
  //   } else {
  //     return true;
  //   }
  // });

  async function fetchDBSet() {
    setIsLoading(true);
    if (selectedProjectType) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/data-processing/db-set`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const { data } = await response.json();
          setDataDBSet(data);
        } else {
          setDataDBSet([]);
        }
      } catch (error) {
        console.error(error);
      }
    } else if (!accessToken) {
      setDataDBSet([]);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchDBSet();
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  async function fetchLogDB() {
    setIsLoading(true);
    if (selectedProjectType) {
      let queryString = "";

      if (selectedDBSet && selectedDBSet !== "") {
        queryString += `db_set_ids=${selectedDBSet}`;
      }

      if (selectedPeriods && selectedPeriods !== "") {
        queryString += (queryString ? "&" : "") + `periods=${selectedPeriods}`;
      }

      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/data-processing?project_type=${selectedProjectType}` +
        (queryString ? `&${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          const { data } = await response.json();
          setDataLogDB(data);
        } else {
          setDataLogDB([]);
        }
      } catch (error) {
        console.error(error);
      }
    } else if (!accessToken) {
      setDataLogDB([]);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchLogDB(selectedProjectType, selectedDBSet, selectedPeriods);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedProjectType, selectedDBSet, selectedPeriods]);

  async function fetchPeriod() {
    setIsLoading(true);
    if (selectedProjectType) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/data-processing/period?project_type=${selectedProjectType}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const { data } = await response.json();
          setDataPeriod(data);
        } else {
          setDataPeriod([]);
        }
      } catch (error) {
        console.error(error);
      }
    } else if (!accessToken) {
      setDataPeriod([]);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchPeriod(selectedProjectType);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedProjectType]);

  const handleOpenRetailerModal = () => {
    setOpenRetailerModal(true);
  };

  const handleRefresh = () => {
    if (
      selectedProjectType === "rta_mt" ||
      (selectedProjectType && selectedPeriod)
    ) {
      fetchPreparationData(
        selectedProjectType,
        selectedPeriod,
        selectedRetailer
      );
      fetchSyncRawdata(
        accessToken,
        setDataSyncRawdata,
        selectedProjectType,
        selectedPeriod
      );
      fetchPeriod(selectedProjectType);
      if (selectedProjectType === "rta_mt") {
        fetchPeriodOptions(selectedProjectType);
      }
    } else {
      setPreparationData([]);
    }
  };

  const handleRefreshDataPreparation = () => {
    fetchLogDB(selectedProjectType, selectedDBSet, selectedPeriods);
    fetchPeriod(selectedProjectType);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchPreparationData(
        selectedProjectType,
        selectedPeriod,
        selectedRetailer
      );
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedProjectType, selectedPeriod, selectedRetailer]);

  const handleGenerate = async () => {
    const formData = {
      project_type: selectedProjectType,
      db_set_ids: selectedDBSet,
      periods: selectedPeriods,
    };

    if (formData) setIsLoading(true);
    {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/data-processing`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(formData),
          }
        );

        if (response.ok) {
          toast.success("Berhasil generate DB!");
          handleCloseModal();
          handleRefreshDataPreparation();
        } else {
          const message = await response.json();
          toast.error(message.detail);
        }
      } catch (error) {
        console.error("Error:", error);
      }
      setIsLoading(false);
    }
  };

  const previousPeriodOptions = periodOptions.filter(
    (option) => option.period < selectedPeriod
  );

  const handleProjectTypeChange = (event) => {
    setSelectedProjectType(event.target.value);
    setSelectedPeriod("");
    setSelectedPreviousPeriod("");
    setSelectedDBSet("");
    setSelectedPeriods("");
  };

  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
    setSelectedPreviousPeriod("");
    setAlreadyRunCreateDataPrep(false);
  };

  const handlePreviousPeriodChange = (event) => {
    setSelectedPreviousPeriod(event.target.value);
    setAlreadyRunCreateDataPrep(false);
  };

  const handleRetailerChange = (event) => {
    setSelectedRetailer(event.target.value);
    setAlreadyRunCreateDataPrep(false);
  };

  const handleCheck = async () => {
    // validation
    if (!selectedProjectType || !selectedPeriod) {
      toast.error(
        "pilih project type dan period untuk membuat log preparation"
      );
      setPreparationData([]);
    } else if (!alreadyRunCreateDataPrep) {
      handleCreateDataPreparation();
    } else if (alreadyRunCreateDataPrep) {
      toast.error("You have already run to create data preparation log.");
    }
  };

  const filteredDBSet = selectedProjectType
    ? dataDBSet.filter((item) => item.project_type === selectedProjectType)
    : dataDBSet;

  const [modalGenerate, setModalGenerate] = useState(false);

  const handleModalGenerate = () => {
    setModalGenerate(true);
  };

  const handleCloseModal = () => {
    setModalGenerate(false);
  };

  const handleCloseAllRetailersUploadModal = () => {
    setOpenAllRetailersUploadModal(false);
  };


  const goToCrosscoding = () => {
    window.open(
      `/data-processing/crosscode-brand?retailer=${selectedRetailer}`,
      "_blank"
    );
  };

  const handleAddNewPeriodModalOpen = () => {
    if (!selectedProjectType || !selectedRetailer) {
      toast.error("Harap mengisi tipe project dan retailer.");
      return;
    } else if (
      selectedProjectType == "rta_mt" &&
      (selectedRetailer == "all-retailers" ||
        selectedRetailer == "All Retailers")
    ) {
      toast.error("Mohon mengisi retailer selain All Retailers");
      return;
    } else {
      setOpenRetailerModal(true);
    }
  };

  const handleSyncModalOpen = () => {
    if (!selectedPeriod || !selectedProjectType) {
      toast.error("Harap mengisi period dan tipe project");
    } else {
      setSyncModalOpen(true);
    }
  };

  const handleSyncModalClose = () => {
    setSyncModalOpen(false);
  };

  const handleProcessSync = async () => {
    try {
      const formData = {
        project_type: selectedProjectType,
        period: selectedPeriod,
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/process_queue/sync_rawdata`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.status === 200) {
        toast.success("Data akan disinkronisasikan dari mobile ke web", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setSyncModalOpen(false);
        fetchSyncRawdata(
          accessToken,
          setDataSyncRawdata,
          selectedProjectType,
          selectedPeriod
        );
      } else if (response.status === 400) {
        toast.error("Sedang ada proses yang berjalan, harap tunggu", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setSyncModalOpen(false);
      } else {
        toast.error("Ada masalah saat sinkronisasi data", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating process queue:", error);
    }
  };

  async function createExportProcess() {
    setIsLoading(true);
    try {
      const formData = {
        title: `Data Preparation Rawdata ${selectedProjectType.toUpperCase()} - ${selectedPeriods}`,
        project_type: selectedProjectType.toLowerCase(),
        periods: selectedPeriods
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/process_queue/data_preparation_rawdata`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (
        response.status === 201 ||
        response.status === 200 ||
        response.status === 202
      ) {
        toast.success("data akan diproses kedalam antrian", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const message = await response.json();
        toast.error(message?.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 404) {
        toast.error("data tidak ditemukan", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("ada masalah saat menyimpan data", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating process queue:", error);
    }
    setIsLoading(false);
  }

  const handleConfirmationExport = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/process_queue/data_preparation_rawdata/${selectedProjectType.toLowerCase()}/${selectedPeriods}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      const { data } = await response.json();
      setOpenDialogConfirmationExport(true);
      setViewDataExport({
        title: data.data.title ?? "rawdata",
        process_at: data.process_at,
      });
    } else if (response.status === 400 || response.status === 404) {
      const { detail } = await response.json();
      toast.error(detail || "Data sedang diproses", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    } else {
      const { detail } = await response.json();
      toast.error(
        detail || "Tidak ditemukan excel, klik Process terlebih dahulu",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        }
      );
    }
    setIsLoading(false);
  };

  const handleExport = async () => {
    try {
      const queryParams = new URLSearchParams();
      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/process_queue/data_preparation_rawdata/export/${selectedProjectType.toLowerCase()}/${selectedPeriods}` +
        (queryString ? `&${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        const blob = await response.blob();
        const filename = `Data Preparation - Rawdata ${selectedProjectType.toUpperCase()} - ${selectedPeriods}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success(`rawdata berhasil di export!`);
        handleCloseDialog();
      } else {
        const message = await response.json();
        toast.error(
          message.detail || "An error occurred while exporting data."
        );
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while exporting data.");
    }
  };

  const handleCloseDialog = () => {
    setOpenDialogConfirmationExport(false);
    // clear data
    setViewDataExport({
      title: "",
      process_at: "",
    });
  };

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Data Processing"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Data Processing"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div className="content" style={{ padding: "2rem" }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={12} md={8}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm="auto">
                <Autocomplete
                  options={projectTypes}
                  getOptionLabel={(option) => option.label}
                  value={
                    projectTypes.find(
                      (type) => type.value === selectedProjectType
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const value = newValue ? newValue.value : "";
                    setSelectedProjectType(value);
                    setSelectedPeriod("");
                    setSelectedPreviousPeriod("");
                    setSelectedRetailer("All Retailers");
                    setSelectedDBSet("");
                    setSelectedPeriods("");
                    setAlreadyRunCreateDataPrep(false);
                  }}
                  disableClearable
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipe Project"
                      className="reporting-textfield"
                    />
                  )}
                  sx={{ width: 250 }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4}>
            {dataSyncRawdata && (
              <>
                {dataSyncRawdata.status === "done" && (
                  <p style={{ margin: 0, color: "#747474" }}>
                    {selectedProjectType.toUpperCase()} {selectedPeriod} Rawdata
                    synchronization was completed on{" "}
                    {dataSyncRawdata.process_at}
                  </p>
                )}
                {dataSyncRawdata.status === "progress" && (
                  <p style={{ margin: 0, color: "#747474" }}>
                    {dataSyncRawdata.title} in {dataSyncRawdata.status}...
                  </p>
                )}
              </>
            )}
          </Grid>
        </Grid>

        {/* Data Preparation */}
        <p style={{ fontWeight: "600", fontSize: "18px", marginTop: "20px" }}>
          Data Preparation
        </p>
        <Card
          sx={{
            mt: 1,
            p: { xs: 2, sm: 3 },
            position: "relative",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
            direction={{ xs: "column", sm: "row" }}
            wrap="wrap"
          >
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <TextField
                label="Current Period"
                select
                size="small"
                value={selectedPeriod}
                onChange={handlePeriodChange}
                className="reporting-textfield"
                sx={{ width: 220 }}
              >
                {periodOptions.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.period}
                  </MenuItem>
                ))}
              </TextField>

              {selectedProjectType === "rta_gt" && (
                <TextField
                  label="Previous Period"
                  select
                  size="small"
                  value={selectedPreviousPeriod}
                  onChange={handlePreviousPeriodChange}
                  className="reporting-textfield"
                  sx={{ width: 220 }}
                >
                  {previousPeriodOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.period}
                    </MenuItem>
                  ))}
                </TextField>
              )}

              {selectedProjectType === "rta_mt" && (
                <Autocomplete
                  size="small"
                  options={optionsWithAll || []}
                  getOptionLabel={(item) => item.retailer || ""}
                  value={
                    optionsWithAll?.find(
                      (item) => item.retailer === selectedRetailer
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleRetailerChange({
                      target: { value: newValue ? newValue.retailer : "" },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Retailer"
                      className="reporting-textfield"
                      sx={{ minWidth: 240 }}
                    />
                  )}
                  isOptionEqualToValue={(item, value) =>
                    item.retailer === value.retailer
                  }
                  disableClearable
                />
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: { xs: "flex-start", sm: "flex-end" },
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {selectedProjectType === "rta_mt" &&
                selectedRetailer !== "All Retailers" &&
                selectedPeriod && (
                  <Button
                    className="button-pros"
                    variant="contained"
                    sx={{
                      backgroundImage: isTimeDisabled
                        ? "linear-gradient(#088b99, #047a89)"
                        : "linear-gradient(#0ab9cc, #069dae)",
                      border: "1px solid hsl(186, 89.90%, 27.30%)",
                      borderRadius: "4px",
                      color: "#fff",
                      fontSize: { xs: "14px", sm: "16px" },
                      padding: "4px 10px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                      },
                    }}
                    onClick={goToCrosscoding}
                    disabled={
                      selectedProjectType === "rta_mt"
                        ? isLoading
                        : isLoading || isTimeDisabled
                    }
                  >
                    {isLoading ? "Loading..." : "Crosscoding Brand"}
                  </Button>
                )}

              {selectedProjectType === "rta_mt" &&
                selectedRetailer == "All Retailers" &&
                selectedPeriod && (
                  <Button
                    className="button-pros"
                    variant="contained"
                    sx={{
                      backgroundImage: isTimeDisabled
                        ? "linear-gradient(#088b99, #047a89)"
                        : "linear-gradient(#0ab9cc, #069dae)",
                      border: "1px solid hsl(186, 89.90%, 27.30%)",
                      borderRadius: "4px",
                      color: "#fff",
                      fontSize: { xs: "14px", sm: "16px" },
                      padding: "4px 10px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                      },
                    }}
                    onClick={() => setOpenAllRetailersUploadModal(true)}
                    disabled={
                      selectedProjectType === "rta_mt"
                        ? isLoading
                        : isLoading || isTimeDisabled
                    }
                  >
                    {isLoading ? "Loading..." : "All Retailers Upload"}
                  </Button>
                )}

              <Button
                className="button-pros"
                variant="contained"
                sx={{
                  backgroundImage: isTimeDisabled
                    ? "linear-gradient(#088b99, #047a89)"
                    : "linear-gradient(#0ab9cc, #069dae)",
                  border: "1px solid hsl(186, 89.90%, 27.30%)",
                  borderRadius: "4px",
                  color: "#fff",
                  fontSize: { xs: "14px", sm: "16px" },
                  padding: "4px 10px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                  },
                }}
                onClick={
                  selectedProjectType === "rta_mt"
                    ? handleAddNewPeriodModalOpen
                    : handleSyncModalOpen
                }
                disabled={
                  selectedProjectType === "rta_mt"
                    ? isLoading
                    : isLoading || isTimeDisabled
                }
              >
                {isLoading
                  ? "Loading..."
                  : selectedProjectType === "rta_mt"
                  ? "Add New Period Data"
                  : "Sync Rawdata"}
              </Button>

              <Button
                className="button-pros"
                variant="contained"
                sx={{
                  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                  border: "1px solid hsl(186, 89.90%, 27.30%)",
                  borderRadius: "4px",
                  color: "#fff",
                  fontSize: { xs: "14px", sm: "16px" },
                  padding: "4px 10px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                  },
                }}
                onClick={handleRefresh}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Refresh Status ..."}
              </Button>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} md={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { sm: "start" },
                  gap: 2,
                }}
              >
                <Typography variant="subtitle1" sx={{ mt: 0 }}>
                  Steps
                </Typography>
                <Box sx={{ flex: 1 }}>
                  <TablePreparation
                    preparationData={preparationData}
                    handleRefresh={handleRefresh}
                    isLoading={isLoading}
                    projectType={selectedProjectType}
                    currentPeriod={selectedPeriod}
                    previousPeriod={selectedPreviousPeriod}
                    isTimeDisabled={isTimeDisabled}
                    selectedRetailer={selectedRetailer}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>

        {/* Data Processing */}
        <p style={{ fontWeight: "600", fontSize: "18px", marginTop: "30px" }}>
          Data Processing
        </p>
        <Card
          sx={{
            mt: 1,
            p: { xs: 2, sm: 3 },
            position: "relative",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ mt: 0, mb: { xs: 1, sm: 0 }, color: "#000" }}
                >
                  DB SET
                </Typography>

                <FormControl
                  sx={{
                    flex: 1,
                    maxWidth: 300,
                    height: 80,
                    overflowY: "auto",
                    border: "1px solid #a9a9a9",
                    borderRadius: "4px",
                    px: 1,
                    py: 1,
                  }}
                >
                  {filteredDBSet.map((item) => (
                    <FormControlLabel
                      key={item.id}
                      sx={{
                        height: 30,
                        px: 1,
                        backgroundColor: selectedDBSet.includes(item.id)
                          ? "#e0e0e0"
                          : "inherit",
                      }}
                      control={
                        <Checkbox
                          sx={{ display: "none" }}
                          onChange={(event) =>
                            handleCheckboxChange(event, item.id)
                          }
                          checked={selectedDBSet.includes(item.id)}
                          value={item.id}
                        />
                      }
                      label={item.base_name}
                    />
                  ))}
                </FormControl>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: { xs: "flex-start", md: "flex-end" },
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {/* <Button
                variant="contained"
                sx={{
                  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                  border: "1px solid hsl(186, 89.90%, 27.30%)",
                  borderRadius: "4px",
                  color: "#fff",
                  fontSize: { xs: "14px", sm: "16px" },
                  padding: "4px 10px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                  },
                }}
                onClick={() => {
                  if (!selectedProjectType || !selectedPeriods) {
                    toast.error(
                      "pilih project type dan period untuk melakukan process export rawdata"
                    );
                  } else {
                    createExportProcess();
                  }
                }}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Process"}
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                  border: "1px solid hsl(186, 89.90%, 27.30%)",
                  borderRadius: "4px",
                  color: "#fff",
                  fontSize: { xs: "14px", sm: "16px" },
                  padding: "4px 10px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                  },
                }}
                onClick={() => {
                  if (!selectedProjectType || !selectedPeriods) {
                    toast.error(
                      "pilih project type dan period untuk melakukan pengecheckan process export rawdata"
                    );
                  } else {
                    handleConfirmationExport();
                  }
                }}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Download"}
              </Button> */}
              <Button
                variant="contained"
                sx={{
                  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                  border: "1px solid hsl(186, 89.90%, 27.30%)",
                  borderRadius: "4px",
                  color: "#fff",
                  fontSize: { xs: "14px", sm: "16px" },
                  padding: "4px 10px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                  },
                }}
                onClick={handleModalGenerate}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Generate DB ..."}
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                  border: "1px solid hsl(186, 89.90%, 27.30%)",
                  borderRadius: "4px",
                  color: "#fff",
                  fontSize: { xs: "14px", sm: "16px" },
                  padding: "4px 10px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                  },
                }}
                onClick={handleRefreshDataPreparation}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Refresh Status ..."}
              </Button>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { sm: "start" },
                  gap: 2,
                }}
              >
                <Typography variant="subtitle1" sx={{ mb: 1.5 }}>
                  Period
                  {(() => {
                    const selectedCount = selectedPeriods
                      .split(",")
                      .filter(Boolean).length;
                    if (selectedCount === 0) return null;

                    return (
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{
                          display: "block",
                          color: "#555",
                          fontWeight: "normal",
                          mt: 0.5,
                        }}
                      >
                        {selectedCount} item <br /> terpilih
                      </Typography>
                    );
                  })()}
                </Typography>
                <Box sx={{ flex: 1 }}>
                  <TablePeriod
                    handlePeriodsClick={handlePeriodsClick}
                    isLoading={isLoading}
                    dataPeriod={dataPeriod}
                    selectedPeriods={selectedPeriods}
                    isAllPeriodsSelected={isAllPeriodsSelected}
                    handleSelectAllPeriods={handleSelectAllPeriods}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={9}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { sm: "start" },
                  gap: 2,
                }}
              >
                <Typography variant="subtitle1" sx={{ mt: 0 }}>
                  Generate DB Log
                </Typography>
                <Box sx={{ flex: 1 }}>
                  <TableLogDB isLoading={isLoading} dataLogDB={dataLogDB} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>

        <ModalGenerateDB
          modalGenerate={modalGenerate}
          handleCloseModal={handleCloseModal}
          handleGenerate={handleGenerate}
          isLoading={isLoading}
        />

        <ModalUploadRetailerTemp
          open={openRetailerModal}
          onSuccess={""}
          onClose={() => setOpenRetailerModal(false)}
          uploadRetailerId={selectedRetailer}
          currentPeriod={""}
        />

        <ModalSyncRawdata
          open={syncModalOpen}
          onClose={handleSyncModalClose}
          isLoading={isLoading}
          handleClick={handleProcessSync}
          isTimeDisabled={isTimeDisabled}
          textKonfirmasi={`Apakah anda yakin ingin melakukan sinkronisasi rawdata ${selectedProjectType} period ${selectedPeriod}?`}
        />

        <AllRetailersUploadModal
          open={openAllRetailersUploadModal}
          onClose={handleCloseAllRetailersUploadModal}
          accessToken={accessToken}
          currentPeriod={selectedPeriod}
        />

        <ModalConfirmation
          open={openDialogConfirmationExport}
          onClose={handleCloseDialog}
          title={"Konfirmasi Download"}
          confirmationText={"Yes"}
          description={`Ditemukan ${viewDataExport.title} terakhir diproses pada ${viewDataExport.process_at}. Apakah anda yakin ingin download data ini?`}
          isLoading={isLoading}
          handleClick={handleExport}
        />
      </div>
    </div>
  );
}

export default DataProcessing;